import React, { useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { deviceSizeNumber, windowMaxWidth } from '../../components/ui/Layout/breakpoints';
import { setSplitscreenMode } from '../../redux/layout/slice';

const MainWrapper = styled.div`
  background-color: var(--secondary-whisper);
  font-weight: var(--font-weight-regular);
  height: 100vh;

  @supports (height: 100lvh;) {
    height: 100lvh;
  }

  @media ${windowMaxWidth.mobile} {
    height: 100dvh;
  }

  margin-top: 0;
  position: relative;

  .page-with-header {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: var(--secondary-whisper);

    @media (${windowMaxWidth.mobile}) {
      height: auto;
    }
  }

  .main-layout {
    margin-bottom: 30px;
    min-height: 0;
  }

  .page-wrapper {
    box-sizing: content-box;
    display: flex;
    flex-direction: column;
    overflow: auto;
    scrollbar-color: rgb(136 136 136 / 30%) transparent;
    scrollbar-width: thin;
    position: relative;
    align-items: stretch;

    @media (${windowMaxWidth.mobile}) {
      margin-top: 60px;
    }
  }

  .page-content {
    max-width: 1840px;
    height: calc(100vh - 60px);
    margin: 0 auto;
    width: 100%;
    overflow: auto;

    @supports (height: 100dvh) {
      height: calc(100dvh - 60px);
    }

    @media (${windowMaxWidth.splitScreen}) {
      overflow-y: auto;
    }

    @media (${windowMaxWidth.mobile}) {
      height: auto;
    }
  }

  .ant-popover {
    z-index: 999;
  }
`;

const StyledMainWrapper = ({ setSplitscreenMode, ...rest }) => {
  useEffect(() => {
    const initialSplitScreenMode = window.innerWidth <= deviceSizeNumber.splitScreen;
    setSplitscreenMode(initialSplitScreenMode);

    const updateSplitScreenMode = () => {
      const _isSplitScreen = window.innerWidth <= deviceSizeNumber.splitScreen;
      setSplitscreenMode(_isSplitScreen);
    };

    window.addEventListener('resize', updateSplitScreenMode);

    return () => window.removeEventListener('resize', updateSplitScreenMode);
  }, [setSplitscreenMode]);

  return <MainWrapper {...rest} />;
};

const mapDispatchToProps = {
  setSplitscreenMode
};

export default connect(null, mapDispatchToProps)(StyledMainWrapper);
